var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningUnfilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 1.38739C8.168 1.38739 1 8.55539 1 17.3874C1 26.2194 8.168 33.3874 17 33.3874C25.832 33.3874 33 26.2194 33 17.3874C33 8.55539 25.832 1.38739 17 1.38739Z",
    stroke: "#C61A2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0005 26.9874C15.8272 26.9874 14.8672 26.0274 14.8672 24.8541C14.8672 23.6807 15.8272 22.7207 17.0005 22.7207C18.1739 22.7207 19.1339 23.6807 19.1339 24.8541C19.1339 26.0274 18.1739 26.9874 17.0005 26.9874Z",
    fill: "#C61A2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4426 10.4434L18.7279 18.9981C18.6533 19.8941 17.9066 20.5874 16.9999 20.5874C16.0933 20.5874 15.3466 19.8941 15.2719 18.9981L14.5573 10.4434C14.4399 9.01405 15.5599 7.78738 16.9999 7.78738C18.3653 7.78738 19.4533 8.89672 19.4533 10.2407C19.4533 10.3047 19.4533 10.3794 19.4426 10.4434Z",
    fill: "#C61A2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningUnfilled);
export default __webpack_public_path__ + "static/media/warningUnfilled.15173c18f49a38df32e727d41d1722e2.svg";
export { ForwardRef as ReactComponent };